import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Card, IconButton, Typography } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { useTranslation } from 'react-i18next';

interface IProps {
  message?: string;
  details?: string;
  callback: (event: any) => any;
  close?: Dispatch<SetStateAction<boolean>>;
  margins?: string;
}

const ErrorComponent: React.FC<IProps> = ({
  close,
  message,
  details,
  margins = '50px 0',
  callback
}: IProps) => {
  const [showDetailsState, setShowDetails] = useState(false);
  const { t: translate } = useTranslation();

  const emitReload = () => {
    callback('Hey Popsie, How’s it going?');
  };

  const showDetails = () => {
    setShowDetails(!showDetailsState);
  };

  const closeTrigger = () => {
    if (close) {
      close(true);
    }
  };

  return (
    <Card
      elevation={9}
      style={{
        width: '600px',
        height: '50vh',
        margin: margins,
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', margin: '20px' }}>
        <div
          style={{
            display: 'flex',
            height: '100%',
            borderBottom: 'solid #3f51b5 1px'
          }}
        >
          <Button
            style={{
              width: '100%'
            }}
            color="primary"
            endIcon={<RefreshIcon />}
            onClick={emitReload}
          >
            {translate('components.errorComponent.reload', 'Reload')}
          </Button>
          {details && (
            <Button
              style={{
                width: '100%'
              }}
              color="primary"
              onClick={showDetails}
            >
              {showDetailsState
                ? translate('components.errorComponent.hideDetails', 'Hide details')
                : translate('components.errorComponent.showDetails', 'Show details')}
            </Button>
          )}
          <IconButton onClick={closeTrigger}>
            <CancelPresentationIcon />
          </IconButton>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            margin: '16px'
          }}
        >
          <Typography
            style={{
              color: '#cb4949'
            }}
          >
            {message}
          </Typography>
          {showDetailsState && (
            <Typography
              style={{
                fontSize: '14px'
              }}
            >
              {details}
            </Typography>
          )}
        </div>
      </div>
    </Card>
  );
};

export default ErrorComponent;
